module.exports = __webpack_public_path__ + "static/media/wall-skull.48a0690c.png";